<template>
    <section style="display: flex; flex-direction: column; justify-content: space-between;" class="content">
        <vue-image-crop-upload
            v-model="showImageCrop"
            langType="pt-br"
            @crop-success="cropImage"
            :noCircle="true"
            :width="200"
            :height="200"
        ></vue-image-crop-upload>
        <vue-image-crop-upload
            v-model="showBannerImageCrop"
            langType="pt-br"
            @crop-success="cropBannerImage"
            :noCircle="true"
            :width="640"
            :height="300"
        ></vue-image-crop-upload>
        <div style="font-weight: 600; display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; font-weight: 600; ">
                ASSOCIAR MARCA AO PRODUTO
                <div class="dot"></div>
                <div>
                    {{ brandProducts.length }}
                </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; width: 280px;">
                <div style="max-width: 200px;">
                    <a class="btn btn--border-only">
                        <div style="display: flex; align-items: center; width: 100%;">
                            <div style="margin-right: 5px;">
                                <icon name="search"/>
                            </div>
                            <input type="text" class="input input-search" style="border:0; margin-bottom: 5px; text-transform: none;" placeholder=""
                                @input="onSearchChange($event.target.value || '', getBrandProducts)" :value="filters.search">
                        </div>
                    </a>
                </div>
                <div class="box-add-icon " @click="openModalAdd()">
                    <fa size="lg" icon="plus"/>
                </div>
            </div>
        </div>
        <table class="principal-table">
            <thead>
                <th style="text-align: left; cursor: pointer;" @click="setOrderByName(getBrandProducts)">Produto {{ getSelectedOrder }}</th>
                <th style="text-align: left;">Marca</th>
                <th style="text-align: left;">Nome complementado</th>
            </thead>
            <tbody>
                <tr v-for="brandProduct of brandProducts" :key="brandProduct.id" class="item" :class="{ 'disabled-row': brandProduct.status === 'inactive' }">
                    <td style="text-align: left;">{{ brandProduct.product.name }}</td>
                    <td style="text-align: left;">{{ brandProduct.brand && brandProduct.brand.name }}</td>
                    <td style="text-align: left;">{{ brandProduct && brandProduct.name }}</td>
                    <td style="width: 60px;" class="edit-icon" @click="editBrandProduct(brandProduct)">
                        <fa size="lg" icon="edit"></fa>
                    </td>
                </tr>
            </tbody>
        </table>
        <div>
            <!-- <div style="float:right; width: 200px;">
                <a href="javascript:void(0)" class="btn button-gradient" style="float: right">
                    Salvar alterações
                </a>
            </div> -->
            <app-modal v-if="showModal" @close="closeModalEdit()" @action="submit()">
                <template slot="header">
                    <div style="margin-right: 20px; color: #C3C5C6;">
                        EDITAR PRODUTO DA MARCA
                    </div>
                </template>
                <template slot="body">
                    <div style="width: 500px;">
                        <div v-if="brandProductToEdit.bannerImageUrl" @click="cropBannerImage(null)" style="cursor: pointer; position: absolute; top: 20px;">
                            <icon name="delete" width="25" height="25"/>
                        </div>
                        <div style="margin-bottom: 20px;">
                            <img v-if="brandProductToEdit.bannerImageUrl" style="width: 500px; height: 250px; border-radius: 5px;" 
                                :src="brandProductToEdit.bannerImageUrl" alt="Imagem do produto">
                            <button style="width: 100%; font-size: 1em;" class="btn" @click="showBannerImageCrop = true">
                                Adicionar banner padrão (opcional)
                            </button>
                        </div>
                        <div style="display: flex; justify-content: space-between; width: 500px;">
                            <div style="display: flex; justify-content: space-between;">
                                <div v-if="brandProductToEdit.imageUrl" @click="cropImage('')" style="cursor: pointer; position: relative; left: 30px;">
                                    <icon name="delete" width="25" height="25"/>
                                </div>
                                <div @click="showImageCrop = true" style="cursor: pointer;">
                                    <div v-if="brandProductToEdit.imageUrl">
                                        <img style="width: 200px; height: 200px; border-radius: 5px;" 
                                            :src="brandProductToEdit.imageUrl" alt="Imagem do produto">
                                        <div>
                                            <button style="width: 100%; font-size: 1em;" class="btn">Editar imagem</button>
                                        </div>
                                    </div>
                                    <div v-else style="width: 200px; height: 200px; border-radius: 5px; background: #666; display: flex; align-items: center; justify-content: center; color: white;">
                                        Adicionar imagem
                                    </div>
                                </div>
                                <div style="margin-left: 20px;">
                                    <div>
                                        Complemento do nome (opcional)
                                        <input type="text" class="input input-config" style="text-transform: none;" placeholder="Digite o nome do produto da marca" 
                                            :value="brandProductToEdit.name"
                                            @input="brandProductToEdit.name = $event.target.value">
                                    </div>
                                    <div style="display: flex; justify-content: space-between; margin-top: 10px;">
                                        <div>
                                            Descrição (opcional)
                                            <input type="text" class="input input-config" style="text-transform: none;" placeholder="Digite o descrição do produto da marca" 
                                                :value="brandProductToEdit.description"
                                                @input="brandProductToEdit.description = $event.target.value">
                                        </div>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        Produto
                                        <treeselect style="margin-top: 10px;" ref="tree" v-model="brandProductToEdit.productId" placeholder="Selecione" :required="false"
                                            :multiple="false" :options="getProducts" :appendToBody="true" :disable-branch-nodes="true"/>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        Marca
                                        <treeselect style="margin-top: 10px;" ref="tree" v-model="brandProductToEdit.brandId" placeholder="Selecione (opcional)" :required="false"
                                            :multiple="false" :options="getBrands" :appendToBody="true" :disable-branch-nodes="true"/>
                                    </div>
                                    <div>
                                        <div style="margin-top: 20px;">
                                            <app-switch class="switch-toggle" 
                                                v-model="brandProductToEdit.isActive" 
                                                :label="`Produto da marca ativo no Zepplin`"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </app-modal>

            <app-modal v-if="showModalAdd" @close="closeModalAdd()" btnActionName="Adicionar" @action="submit()">
                <template slot="header">
                    <div style="margin-right: 20px; color: #C3C5C6;">
                        ADICIONAR NOVO PRODUTO DA MARCA
                    </div>
                </template>
                <template slot="body">
                    <div style="width: 500px;">
                        <div v-if="brandProductToEdit.bannerImageUrl" @click="cropBannerImage(null)" style="cursor: pointer; position: absolute; top: 20px;">
                            <icon name="delete" width="25" height="25"/>
                        </div>
                        <div style="margin-bottom: 20px;">
                            <img v-if="brandProductToEdit.bannerImageUrl" style="width: 500px; height: 250px; border-radius: 5px;" 
                                :src="brandProductToEdit.bannerImageUrl" alt="Imagem do produto">
                            <button style="width: 100%; font-size: 1em;" class="btn" @click="showBannerImageCrop = true">
                                Adicionar banner padrão (opcional)
                            </button>
                        </div>
                        <div style="display: flex; justify-content: space-between; width: 500px;">
                            <div style="display: flex; justify-content: space-between;">
                                <div v-if="brandProductToEdit.imageUrl" @click="cropImage('')" style="cursor: pointer; position: relative; left: 30px;">
                                    <icon name="delete" width="25" height="25"/>
                                </div>
                                <div @click="showImageCrop = true" style="cursor: pointer;">
                                    <div v-if="brandProductToEdit.imageUrl">
                                        <img style="width: 200px; height: 200px; border-radius: 5px;" 
                                            :src="brandProductToEdit.imageUrl" alt="Imagem do produto">
                                        <div>
                                            <button style="width: 100%; font-size: 1em;" class="btn">Editar imagem</button>
                                        </div>
                                    </div>
                                    <div v-else style="width: 200px; height: 200px; border-radius: 5px; background: #666; display: flex; align-items: center; justify-content: center; color: white;">
                                        Adicionar imagem
                                    </div>
                                </div>
                                <div style="margin-left: 20px;">
                                    <div>
                                        Complemento do nome (opcional)
                                        <input type="text" class="input input-config" style="text-transform: none;" placeholder="Digite o nome do produto da marca" 
                                            :value="brandProductToEdit.name"
                                            @input="brandProductToEdit.name = $event.target.value">
                                    </div>
                                    <div style="display: flex; justify-content: space-between; margin-top: 10px;">
                                        <div>
                                            Descrição (opcional)
                                            <input type="text" class="input input-config" style="text-transform: none;" placeholder="Digite o descrição do produto da marca" 
                                                :value="brandProductToEdit.description"
                                                @input="brandProductToEdit.description = $event.target.value">
                                        </div>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        Produto
                                        <treeselect style="margin-top: 10px;" ref="tree" v-model="brandProductToEdit.productId" placeholder="Selecione" :required="false"
                                            :multiple="false" :options="getProducts" :appendToBody="true" :disable-branch-nodes="true"/>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        Marca
                                        <treeselect style="margin-top: 10px;" ref="tree" v-model="brandProductToEdit.brandId" placeholder="Selecione (opcional)" :required="false"
                                            :multiple="false" :options="getBrands" :appendToBody="true" :disable-branch-nodes="true"/>
                                    </div>
                                    <div>
                                        <div style="margin-top: 20px;">
                                            <app-switch class="switch-toggle" 
                                                v-model="brandProductToEdit.isActive" 
                                                :label="`Produto da marca ativa no Zepplin`"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </app-modal>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import ZepplinProductsAPI from '../../../api/zepplin/products'
import FiltersHelper from './FiltersHelper'

export default {
    props: ['user'],
    mixins: [FiltersHelper],
    data() {
        return {
            brandProductToEdit: {
                productId: null,
                brandId: null,
                imageUrl: null,
                bannerImageUrl: null,
                name: null,
                description: null
            },
            showModal: false,
            showModalRemove: false,
            showModalAdd: false,

            brandProducts: [],
            mappedProducts: [],
            mappedBrands: [],

            showImageCrop: false,
            showBannerImageCrop: false
        }
    },
    components: { Treeselect },
    computed: {
        ...mapState('auth', ['company', 'zepplinMasterToken']),
        getProducts() {
            return this.mappedProducts
        },

        getBrands() {
            return this.mappedBrands
        }
    },
    methods: {
        ...mapActions("toast", ["showToast", "showError"]),

        closeModalAdd() {
            this.showModalAdd = false
        },

        closeModalEdit() {
            this.showModal = false
        },

        getProduct(productId) {
            return this.mappedProducts.find(mappedProduct => mappedProduct.value === productId)
        },

        getBrand(brandId) {
            return this.mappedBrands.find(mappedBrand => mappedBrand.value === brandId)
        },

        editBrandProduct(brand) {
            _.assign(this.brandProductToEdit, { ...this.utils.removeReactivity(brand), isActive: brand.status === 'active' ? true : false })
            this.showModal = true
        },

        cropImage(data, url) {
            this.brandProductToEdit.imageUrl = data
        },

        cropBannerImage(data) {
            this.brandProductToEdit.bannerImageUrl = data
        },

        async submit() {
            this.$emit('saving', true)

            const errorMessage = this.validateBrandProductInput()
            if(errorMessage) 
                return this.showError(errorMessage)

            try {
                const brandProductForm = this.handleBrandProductForm(this.brandProductToEdit)
                console.log(brandProductForm)
                if(this.brandProductToEdit.id)
                    await ZepplinProductsAPI.updateBrandProduct(this.brandProductToEdit.id, brandProductForm, { masterToken: this.zepplinMasterToken })
                else
                    await ZepplinProductsAPI.createBrandProduct(brandProductForm, { masterToken: this.zepplinMasterToken })

                await this.getBrandProducts()
                this.showToast({ type: 'success', message: 'Operação realizada com sucesso!' })
            }
            catch(err) {
                console.error(err)
                this.showError('Não foi possível completar a operação.')
                return 
            }
            finally {
                this.$emit('saving', false)
            }

            this.showModal = false            
            this.showModalAdd = false
        },

        handleBrandProductForm({
            name,
            description,
            productId,
            brandId,
            imageUrl,
            bannerImageUrl,
            isActive
        }) {
            return {
                name: name || null,
                description: description || null,
                productId,
                brandId: brandId || null,
                imageUrl: imageUrl || null,
                bannerImageUrl: bannerImageUrl || null,
                status: isActive ? 'active' : 'inactive'
            }
        },

        validateBrandProductInput() {
            if(!this.brandProductToEdit.productId)
                return 'Selecione um produto.'
        },

        openModalAdd() {
            this.brandProductToEdit = {
                name: null,
                productId: null,
                brandId: null,
                imageUrl: '',
                bannerImageUrl: '',
                description: null,
                isActive: true
            }
            this.showModalAdd = true
        },

        async getBrandProducts() {
            this.mappedProducts = await ZepplinProductsAPI.getProducts({ orderName: 'asc' })
                .then(res => 
                    res.data.map(product => {
                        return {
                            label: product.name,
                            id: product.id
                        }
                    }))
            this.mappedBrands = await ZepplinProductsAPI.getBrands({ excludeCompanyBrands: true, orderName: 'asc' })
                .then(res => 
                    res.data.map(brand => {
                        return {
                            label: brand.name,
                            id: brand.id
                        }
                    }))
            this.brandProducts = await ZepplinProductsAPI.getBrandProductsByBrandIds({ ...this.filters, hasInclude: true, isCompanyContext: false })
                .then(res => res.data.filter(brandProduct => !brandProduct.companyId))
            window.removeAppLoading();
        }
    },
    async mounted() {
        window.showAppLoading();
        window.setAppLoadingText("Carregando lista...");
        await this.getBrandProducts()
    }
}
</script>

<style lang="scss" scoped>
    .line {
        width: 100%;
        height: 1px;
        border-bottom: solid 1px #52566281;
    }
    .input-config {
        border-bottom: 1px solid #525662;
        width: 100%;
    }

    .column {
        width: 45%;
        font-weight: 600;
    }

    .content-column {
        margin-top: 20px;
    }

    .content {
        margin-bottom: 50px;
    }

    .item {
        height: 40px;
        text-align: center;
    }

    .footer-config {
        position: fixed;
        bottom: 0;
        padding-top: 2vh;
        padding-bottom: 10vh;
        padding-right: 10vh;
        right: 0;
        background: #23272B;
        width: 100%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.301);
    }

    .active-btn {
        background: #0072E4;
    }

    .edit-icon:hover {
        color: #0072E4;
        cursor: pointer;
    }

    .delete-icon:hover {
        color: #c22f2f9d;
        cursor: pointer;
    }

    .disabled-row {
        opacity: .3;
    }

    .principal-table tbody tr:nth-child(odd) {
        background: rgba(22, 26, 29, 0.404);
    }

    .principal-table {
        margin-top: 20px;
    }

    .box-add-icon {
        width: 50px;
        height: 30px;
        border-radius: 50px;
        background: linear-gradient(89.39deg, #0072E4 -0.59%, #25A0A8 100.95%);
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .box-add-icon:hover {
        background: #0072E4;
    }

    .product-image {
        width: 650px;
        height: 300px;
    }

    .number-input {
        background: transparent;
        color: white;
        font-size: .9em;
        border: none;
        width: 50px;
    }
</style>
